// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 385 ? "84eeec4d" : chunkId) + "." + {"385":"daa9994e290690d3","928":"fc05506bb72d7443"}[chunkId] + ".js";
};